export const invoiceSettlementGerman = {
  via: 'Über {{channel}} beglichen',
  unknown: 'Über den Buchungskanal beglichen',
};

export const invoiceSettlementEnglish = {
  via: 'Settled through {{channel}}',
  unknown: 'Settled through the booking channel',
};
